
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import StepList from "@/components/scope/step-list.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import OutWarehousePrint from "./components/out-warehouse-print.vue";
const setting = namespace("setting");
const inventory = namespace("inventory");
const app = namespace("app");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit", "permitApp")
@Component({
  components: {
    StepList,
    OutWarehousePrint
  }
})
export default class OutWarehouseEdit extends Vue {
  @setting.State serviceMode;
  @inventory.Action outWarehouseComplete;
  @inventory.Action getOutWarehouseDetail;
  @inventory.Action queryInventoryAndNotice;
  @setting.Getter isManageInventory;
  @inventory.Action outWarehouseCancel;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;

  get breadData() {
    return [
      { name: t("warehouse.outbound-manage"), path: "/inventory/out-warehouse" },
      { name: t("v213.Outbound-detail") }
    ];
  }
  detailData: any = { outboundStatus: "9", photoList: [] };
  created() {
    this.init();
  }
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.outWarehouseCancel({
        outboundNo: this.orderId
      }).then(() => {
        this.$message.success(t("finance.cancel-success") as string);
        this.init();
      });
    }
  }
  get orderId() {
    return this.$route.params.id;
  }

  handleComplete() {
    this.btnStartLoading();
    this.outWarehouseComplete({
      outboundNo: this.orderId,
      _httpOptions: { errorMessage: false }
    })
      .then(
        data => {
          this.$message.success(t("warehouse.outbound-success") as string);

          if (data.data.validateInventoryAlert === "1") {
            const partsCodeArr = this.detailData.detailList.map(item => item.partsCode);
            this.queryInventoryAndNotice(partsCodeArr);
          }
          this.init();
          this.showOutConfirmTips = false;
        },
        res => {
          this.showOutConfirmTips = false;
          if (res.code === "speedbiz.inventory.outbound-cost-changed") {
            this.$confirm(res.message, t("v210831.tips"), {
              confirmButtonText: t("v216_6.continue-outbound"),
              cancelButtonText: t("v216_6.temporarily-not-outbound"),
              type: "warning"
            })
              .then(() => {
                this.handleComplete();
              })
              .catch(() => {
                this.init();
              });
          } else {
            this.$message.error(res.message);
          }
        }
      )
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleArriveStore() {
    this.$router.push(`/service/arrive/input/${this.orderId}`);
  }

  init() {
    this.getOutWarehouseDetail({
      outboundNo: this.orderId
    }).then(data => {
      this.detailData = data.data;
    });
  }
  handleLinkOrderView(orderNo) {
    let { href } = this.$router.resolve({
      path: `/service/view/${orderNo}?tenantCode=${this.detailData.tenantCode || ""}`
    });
    window.open(href, "_blank");
  }
  showPrintOrder: boolean = false;
  delegatePrintObj: any = {
    id: "printMer2",
    popTitle: t("service.order-ticket"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  handleShowPrintOrder() {
    this.showPrintOrder = true;
  }
  // 2.10
  showOutConfirmTips: boolean = false;
  handleShowOutConfrimTips() {
    this.showOutConfirmTips = true;
  }
}
